var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_c('Top'),_c('el-backtop',{attrs:{"visibility-height":400},on:{"click":_vm.backTotop}}),_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view',{key:_vm.$route.path}):_vm._e()],1),(!_vm.$route.meta.keepAlive)?_c('router-view',{key:_vm.$route.path}):_vm._e(),_c('Foot')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }